import { render } from "./VariablesView.vue?vue&type=template&id=76c599e6&scoped=true"
import script from "./VariablesView.vue?vue&type=script&lang=js"
export * from "./VariablesView.vue?vue&type=script&lang=js"

import "./VariablesView.vue?vue&type=style&index=0&id=76c599e6&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c599e6"]])

export default __exports__